'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _debounce = require('hs-lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _getters = require('conversations-schema/thread-history/operators/getters');

var _getSessionId = require('conversations-schema/operators/widget-data/getSessionId');

var _ChatHeadingConfigPropType = require('ui-addon-conversations/chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _ChatArea = require('conversations-internal-components/visitor-widget/ChatArea');

var _ChatArea2 = _interopRequireDefault(_ChatArea);

var _resolvedAttachmentGetters = require('conversations-schema/resolved-attachment/operators/resolvedAttachmentGetters');

var _fileMetadataGetters = require('conversations-schema/file-metadata/operators/fileMetadataGetters');

var _getMessagesPageUri = require('../../selectors/widgetDataSelectors/getMessagesPageUri');

var _typingIndicatorConstants = require('../../typing-indicators/constants/typingIndicatorConstants');

var _isPersistedThread = require('../../thread-histories/operators/isPersistedThread');

var _buildFileAttachments = require('../../file-uploads/operators/buildFileAttachments');

var _ConnectedChatAreaAlertContainer = require('../containers/ConnectedChatAreaAlertContainer');

var _ConnectedChatAreaAlertContainer2 = _interopRequireDefault(_ConnectedChatAreaAlertContainer);

var _fileUploadsConstants = require('../../file-uploads/constants/fileUploadsConstants');

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThreadedChatArea = function (_React$Component) {
  _inherits(ThreadedChatArea, _React$Component);

  function ThreadedChatArea(props) {
    _classCallCheck(this, ThreadedChatArea);

    var _this = _possibleConstructorReturn(this, (ThreadedChatArea.__proto__ || Object.getPrototypeOf(ThreadedChatArea)).call(this, props));

    _this.handleRemoveAttachment = function (_ref) {
      var attachment = _ref.attachment;

      _this.props.onRemoveAttachment({
        attachment: attachment,
        thread: _this.props.currentConversation
      });
    };

    _this.handleSelectAttachmentFiles = function (_ref2) {
      var files = _ref2.files;

      if (!files || !files.length) {
        return;
      }

      var file = files.item(0);

      _this.props.onSelectAttachmentFile({
        file: file,
        thread: _this.props.currentConversation
      });
    };

    _this.handleAttachmentClick = function (_ref3) {
      var attachment = _ref3.attachment;

      var fileMetadata = (0, _resolvedAttachmentGetters.getFileMetadata)(attachment);
      var url = (0, _fileMetadataGetters.getUrl)(fileMetadata);

      if (url) {
        window.open(url, '_blank');
      }
    };

    _this.handleAttachmentButtonClick = function () {
      _this.props.trackInteraction('click-to-attach-file', {
        action: 'click to attach file'
      });
    };

    _this.fetchChatHistory = _this.fetchChatHistory.bind(_this);
    _this.handlePublishMessage = _this.handlePublishMessage.bind(_this);
    _this.handleChatInputChange = _this.handleChatInputChange.bind(_this);
    _this.publishTypingMessage = (0, _debounce2.default)(_this.props.publishTypingMessage, _typingIndicatorConstants.SEND_TYPING_MESSAGE_DEBOUNCE_MS, {
      leading: true,
      trailing: false,
      maxWait: _typingIndicatorConstants.SEND_TYPING_MESSAGE_DEBOUNCE_MS
    });
    return _this;
  }

  _createClass(ThreadedChatArea, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.shouldStageInitialMessage) {
        this.props.stageInitialMessage();
      } else {
        this.fetchChatHistory();
      }
    }
  }, {
    key: 'fetchChatHistory',
    value: function fetchChatHistory() {
      var _props = this.props,
          threadHistory = _props.threadHistory,
          fetchThreadHistory = _props.fetchThreadHistory,
          widgetData = _props.widgetData,
          currentThreadId = _props.currentThreadId;


      var threadId = currentThreadId;

      if (!threadId) {
        return;
      }

      var latestStartTime = (0, _getters.getStartTimestamp)(threadHistory);
      var sessionId = (0, _getSessionId.getSessionId)(widgetData);

      fetchThreadHistory({
        startTime: latestStartTime,
        threadId: threadId,
        sessionId: sessionId
      });
    }
  }, {
    key: 'handlePublishMessage',
    value: function handlePublishMessage(_ref4) {
      var text = _ref4.text,
          richText = _ref4.richText,
          quickReply = _ref4.quickReply;

      var fileAttachments = (0, _buildFileAttachments.buildFileAttachments)(this.props.stagedAttachments);
      var url = (0, _getMessagesPageUri.getMessagesPageUri)(this.props.widgetData);

      if (!url && !this.props.livePreview) {
        window.Raven.captureMessage('PUBLISH_MESSAGE_WITH_NO_URL');
      }

      this.publishTypingMessage.cancel();

      this.props.publishMessage({
        text: text,
        richText: richText,
        quickReply: quickReply,
        url: url,
        attachments: fileAttachments
      });
    }
  }, {
    key: 'handleChatInputChange',
    value: function handleChatInputChange() {
      if ((0, _isPersistedThread.isPersistedThread)(this.props.currentConversation)) {
        this.publishTypingMessage({ thread: this.props.currentConversation });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_ChatArea2.default, {
        alert: _react2.default.createElement(_ConnectedChatAreaAlertContainer2.default, {
          thread: this.props.currentConversation
        }),
        assignedResponder: this.props.assignedResponder,
        attachments: this.props.attachments,
        companyName: this.props.companyName,
        consentToCommunicateMessage: this.props.consentToCommunicateMessage,
        potentialResponders: this.props.potentialResponders,
        sendFromResponders: this.props.sendFromResponders,
        chatHeadingConfig: this.props.chatHeadingConfig,
        responders: this.props.responders,
        userId: this.props.userId,
        requiresConsentToCommunicate: this.props.requiresConsentToCommunicate,
        requiresExplicitConsentToProcess: this.props.requiresExplicitConsentToProcess,
        widgetData: this.props.widgetData,
        currentChannel: this.props.currentChannel,
        currentConversation: this.props.currentConversation,
        currentThreadId: this.props.currentThreadId,
        sendVisitorEmailAddress: this.props.sendVisitorEmailAddress,
        fetchChatHistory: this.fetchChatHistory,
        showTypingIndicator: false,
        publishMessage: this.handlePublishMessage,
        republishMessage: this.props.republishMessage,
        chatInputChanged: this.handleChatInputChange,
        mobile: this.props.mobile,
        networkOffline: this.props.networkOffline,
        liveChatLink: this.props.liveChatLink,
        onLinkClick: this.props.onLinkClick,
        hasUnansweredQuickReplyMessage: this.props.hasUnansweredQuickReplyMessage,
        consentToProcess: this.props.consentToProcess,
        threadHistory: this.props.threadHistory,
        typingResponder: this.props.typingResponder,
        stagedAttachments: this.props.stagedAttachments,
        supportsAttachments: this.props.supportsAttachments,
        onAttachmentButtonClick: this.handleAttachmentButtonClick,
        onRemoveAttachment: this.handleRemoveAttachment,
        onSelectAttachmentFiles: this.handleSelectAttachmentFiles,
        onAttachmentClick: this.handleAttachmentClick,
        maxAttachmentFileSize: _fileUploadsConstants.MAX_FILE_SIZE,
        hasCapturedVisitorEmail: this.props.hasCapturedVisitorEmail,
        hasGivenConsentToProcess: this.props.hasGivenConsentToProcess
      });
    }
  }]);

  return ThreadedChatArea;
}(_react2.default.Component);

ThreadedChatArea.propTypes = {
  assignedResponder: (0, _RecordPropType2.default)('Responder'),
  attachments: _react.PropTypes.instanceOf(_immutable.Map).isRequired,
  chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
  companyName: _react.PropTypes.string.isRequired,
  consentToCommunicateMessage: _react.PropTypes.string,
  consentToProcess: _react.PropTypes.func.isRequired,
  currentChannel: _react.PropTypes.string,
  currentConversation: (0, _RecordPropType2.default)('Conversation'),
  currentThreadId: _react.PropTypes.number,
  fetchThreadHistory: _react.PropTypes.func.isRequired,
  hasCapturedVisitorEmail: _react.PropTypes.bool.isRequired,
  hasGivenConsentToProcess: _react.PropTypes.bool.isRequired,
  hasUnansweredQuickReplyMessage: _react.PropTypes.bool,
  liveChatLink: _react.PropTypes.string,
  livePreview: _react.PropTypes.bool,
  mobile: _react.PropTypes.bool,
  networkOffline: _react.PropTypes.bool.isRequired,
  onLinkClick: _react.PropTypes.func.isRequired,
  onRemoveAttachment: _react.PropTypes.func.isRequired,
  onSelectAttachmentFile: _react.PropTypes.func.isRequired,
  potentialResponders: _react.PropTypes.instanceOf(_immutable.List).isRequired,
  publishMessage: _react.PropTypes.func.isRequired,
  publishTypingMessage: _react.PropTypes.func.isRequired,
  republishMessage: _react.PropTypes.func.isRequired,
  requiresConsentToCommunicate: _react.PropTypes.bool.isRequired,
  requiresExplicitConsentToProcess: _react.PropTypes.bool.isRequired,
  responders: _react.PropTypes.instanceOf(_immutable.Map).isRequired,
  sendFromResponders: _react.PropTypes.instanceOf(_immutable.List).isRequired,
  sendVisitorEmailAddress: _react.PropTypes.func.isRequired,
  shouldStageInitialMessage: _react.PropTypes.bool.isRequired,
  stageInitialMessage: _react.PropTypes.func.isRequired,
  stagedAttachments: _react.PropTypes.instanceOf(_immutable.List),
  supportsAttachments: _react.PropTypes.bool.isRequired,
  threadHistory: (0, _RecordPropType2.default)('ThreadHistory'),
  trackInteraction: _react.PropTypes.func.isRequired,
  typingResponder: (0, _RecordPropType2.default)('Responder'),
  userId: _react.PropTypes.number,
  widgetData: (0, _RecordPropType2.default)('WidgetData')
};

ThreadedChatArea.defaultProps = {
  onRemoveAttachment: function onRemoveAttachment() {},
  onSelectAttachmentFile: function onSelectAttachmentFile() {},
  publishTypingMessage: function publishTypingMessage() {}
};

exports.default = ThreadedChatArea;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/threads/components/ThreadedChatArea.js
// module id = 649
// module chunks = 2 3